import React, { useState, useEffect } from "react";
import alanBtn from "@alan-ai/alan-sdk-web";
import { Switch, Route, Link } from "react-router-dom";
import { Grid } from "@material-ui/core";

import Navbar from "./components/navbar/Navbar";
import Worddict from "./components/dict/Worddict";
import Translater from "./components/translater/Translater";

// const alanKey =
//   "c73fc36da8cc8e684999c0d0d05bf3e52e956eca572e1d8b807a3e2338fdd0dc/stage";

const App = () => {
  // const history = useHistory();
  
  // useEffect(() => {
  //   history.go(0);
  // },[])
  // useEffect(() => {
  //   alanBtn({
  //     key: alanKey,
  //     onCommand: ({ command, word,type }) => {
  //       if (command === "wordDict") {
  //         setFinalWord(word);
  //         setFWord(word);
  //         setType(type);

  //       }
  //     },
  //   });
  // }, []);

  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <Navbar />
        </Grid>
        <Switch>
          <Route exact path="/">
            <Worddict />
          </Route>
          <Route exact path="/translater">
            <Translater />
          </Route>
        </Switch>
      </Grid>
    </>
  );
};

export default App;
